import modelExtend from 'dva-model-extend';
import moment from 'moment';

import { saveFile } from 'utils';
import storage from 'utils/storage';
import * as apis from 'services/employee';

import { createAdvanceStaticModel } from './common';


const currentPeriod = storage.getAccountingPeriod();

const opt = {
  apis,
  namespace: 'employee',
  singleAttr: 'employee',
  listAttr: 'employees',
  pathname: '/employee',
  processDataItem: (item) => {
    if (!item.salary) return;
    let currentSalary = null;
    item.salary.forEach((salaryRow) => {
      const startDate = moment(salaryRow.start_date);
      if (startDate.year() === currentPeriod && (!currentSalary || currentSalary.start_date < startDate)) {
        currentSalary = { ...salaryRow, start_date: startDate };
      }
    });
    item.current_salary = currentSalary;
  },
};

const model = createAdvanceStaticModel(opt);

export default modelExtend(model, {
  namespace: 'employee',
  effects: {
    * clearSalary({ payload, output }, { call, put }) {
      const data = yield call(apis.clearSalary, payload);
      output && (output.value = data);
      if (data.success) {
        yield put({ type: 'reload' });
      } else {
        throw data;
      }
    },

    * getTaxNumberRegistrationXml({ payload, output }, { call }) {
      const data = yield call(apis.getTaxNumberRegistrationXml, payload);
      output && (output.value = data);
      if (data.success) {
        saveFile(data.file_name, data.xml_content, 'text/xml');
      } else {
        throw data;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/employee.js